/*
  Studiocare custom product JS (Empire 14)

  RETIRED LOGIC: in v12 this file listened for the `variant-change` event on
  <variant-selection> and rewrote the ex-VAT line client-side.

  In Empire 14 the ex-VAT line is rendered by snippets/product-price.liquid,
  which sits inside the `data-kit-refresh="price"` region of snippets/product.liquid.
  On every variant change (kit:variant-picker:after-change) the theme re-fetches
  the section and replaces that region, so the inc-VAT main price and the
  ex-VAT line are recalculated server-side. No client-side update is needed.

  Note: the v12 code divided variant.price by 1.2. Shopify prices on this store
  look ex-VAT (the Liquid multiplies them by 1.2), so that may have shown the wrong figure.

  Hook kept for future product-page tweaks:
*/
document.addEventListener('kit:variant-picker:after-change', function () {
  /* intentionally empty - price/ex-VAT handled by the server re-render */
});
